import { Box, BoxProps } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { Product } from '@setvi/shared/interfaces';

interface ListPriceProps extends BoxProps {
  product: Product;
  fontSize?: STextProps['size'];
}

export const ListPrice = ({ product, fontSize, ...rest }: ListPriceProps) => (
  <Box display="flex" flexDirection="column" mt={2} {...rest}>
    <SText
      size={fontSize}
      // @ts-ignore
      title={`Lead time: ${product?.custom?.ship_lead_time__business_days || '-'}`}
    />
    <SText
      size={fontSize}
      title={`List: ${
        product?.price
          ? product?.price?.toLocaleString('en-US', {
              currency: 'USD',
              style: 'currency'
            })
          : '-'
      }`}
    />
  </Box>
);
